// CrystalVault — Transaction Modal

import { EXPLORER } from './config.js';

export function showTxModal(title, message) {
  const modal = document.getElementById("tx-modal");
  document.getElementById("tx-title").textContent = title;
  document.getElementById("tx-message").textContent = message;
  document.getElementById("tx-spinner").classList.remove("hidden");
  document.getElementById("tx-success-icon").classList.add("hidden");
  document.getElementById("tx-success-icon").classList.remove("flex");
  document.getElementById("tx-error-icon").classList.add("hidden");
  document.getElementById("tx-error-icon").classList.remove("flex");
  document.getElementById("tx-link").classList.add("hidden");
  document.getElementById("tx-close").classList.add("hidden");
  modal.classList.remove("hidden");
}

export function txModalSuccess(message, txHash) {
  document.getElementById("tx-spinner").classList.add("hidden");
  const icon = document.getElementById("tx-success-icon");
  icon.classList.remove("hidden");
  icon.classList.add("flex");
  document.getElementById("tx-title").textContent = "Success";
  document.getElementById("tx-message").textContent = message;
  if (txHash) {
    const link = document.getElementById("tx-link");
    link.href = EXPLORER + "/tx/" + txHash;
    link.classList.remove("hidden");
  }
  document.getElementById("tx-close").classList.remove("hidden");
}

export function txModalError(message) {
  document.getElementById("tx-spinner").classList.add("hidden");
  const icon = document.getElementById("tx-error-icon");
  icon.classList.remove("hidden");
  icon.classList.add("flex");
  document.getElementById("tx-title").textContent = "Transaction Failed";
  document.getElementById("tx-message").textContent = message;
  document.getElementById("tx-close").classList.remove("hidden");
}

export function initTxModal() {
  document.getElementById("tx-close").addEventListener("click", () => {
    document.getElementById("tx-modal").classList.add("hidden");
  });
}
